const routes = [{
  path: '/feiche/home',
  component: () => import('@/views/feiche/index'),
  name: 'feiche-home',
  meta: {
    title: ''
  }
}, {
  path: '/feiche/insuranceEntering',
  component: () => import('@/views/feiche/insuranceEntering'),
  name: 'feiche-insuranceEntering',
  meta: {
    title: '保单录入'
  }
}, {
  path: '/feiche/entry',
  component: () => import('@/views/feiche/insurance/entry'),
  name: 'feiche-entry',
  meta: {
    title: '保单录入'
  }
}, {
  path: '/feiche/:id/update',
  component: () => import('@/views/feiche/insurance/entry'),
  name: 'feiche-entry-update',
  meta: {
    title: '保单编辑'
  }
}, {
  path: '/feiche/detail/:id',
  component: () => import('@/views/feiche/insurance/entry'),
  name: 'feiche-entry-detail',
  meta: {
    title: '保单详情'
  }
}, {
  path: '/feiche/policy/query',
  component: () => import('@/views/feiche/query'),
  name: 'feiche-policy-query',
  meta: {
    title: '保单查询'
  }
}, {
  path: '/feiche/policy/task',
  component: () => import('@/views/insurance/task'),
  name: 'feiche-policy-task',
  meta: {
    title: '任务列表'
  }
}, {
  path: '/feiche/insuranceCompile',
  component: () => import('@/views/feiche/insuranceEntering'),
  name: 'feiche-insuranceCompile',
  meta: {
    title: '保单编辑'
  }
}, {
  path: '/feiche/insuranceCompile/:id',
  component: () => import('@/views/feiche/insuranceEntering'),
  name: 'feiche-insuranceCompile-detail',
  meta: {
    title: '保单详情'
  }
}, {
  path: '/feiche/endorsement',
  component: () => import('@/views/feiche/endorsement'),
  name: 'feiche-endorsement',
  meta: {
    title: '批单录入'
  }
}, {
  path: '/feiche/entry/endorsement',
  component: () => import('@/views/feiche/insurance/entry'),
  name: 'feiche-entry-endorsement',
  meta: {
    title: '批单录入'
  }
}, {
  path: '/feiche/endorsementCompile',
  component: () => import('@/views/feiche/endorsement'),
  name: 'feiche-endorsementCompile',
  meta: {
    title: '批单编辑'
  }
}, {
  path: '/feiche/endorsementCompile/:id',
  component: () => import('@/views/feiche/endorsement'),
  name: 'feiche-endorsementCompile-detail',
  meta: {
    title: '批单详情'
  }
}, {
  path: '/feiche/:id/endorsement',
  component: () => import('@/views/feiche/insurance/entry'),
  name: 'feiche-entry-endorsement-update',
  meta: {
    title: '批单编辑'
  }
}, {
  path: '/feiche/endorsement/:id',
  component: () => import('@/views/feiche/insurance/entry'),
  name: 'feiche-entry-detail-endorsement',
  meta: {
    title: '批单详情'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/insurance.js